
@defer (when component; hydrate when component) {
  <ng-container *ngComponentOutlet="component; inputs: { context }"/>
}
